<template>
    <div v-loading="loading">
        <div class="brand-menu">
            <div class="g-wrapper brand-menu-text" style="text-align: left;"><a href="/">首页</a> &gt; 我的询价单</div>
        </div>

        <div class="g-wrapper shopcart-main" id="shopcartContainer">
            <table class="m-shopcart-list">
                <thead>
                    <tr>
                        <th class="select">
                            <input type="checkbox" v-model="selectAll" @change="selectAllF" />
                        </th>
                        <th class="goods">商品信息</th>
                        <th class="count">备注</th>
                        <th class="count">状态</th>
                        <th class="total">客户料号</th>
                        <th class="handle">操作</th>
                    </tr>
                </thead>
                <tbody data-gid="1">
                    <tr class="shopcart-goods" v-for="(item, key) in inquiryList" :key="key">
                        <td>
                            <input type="checkbox" class="select tb-check" @change="checkedChange(key)" checked />
                        </td>
                        <td>
                            <div class="m-goods-item">
                                <a :href="'/procInfo?sku=' + item.SKU" class="pic" target="_blank">
                                    <img
                                        :src="'http://mallmgr.cesseon.com/api/Shop/GetImageSize?width=240&name=' + item.PicName + '&type=1'"
                                    />
                                </a>
                                <div class="info">
                                    <p class="title" style="padding-top: 20px;">
                                        <a :href="'/procInfo?sku=' + item.Skuid" target="_blank">{{ item.Skuname }}</a>
                                    </p>
                                    <p class="title">
                                        {{ item.Skuunit }}
                                    </p>
                                </div>
                            </div>
                        </td>
                        <td>
                            {{ item.Skuremark }}
                        </td>
                        <td>
                            {{ item.InquiryStateName }}
                        </td>
                        <td>
                            <el-input v-model="item.CustSKU" placeholder="请输入客户料号" style="width: 140px;"></el-input>
                        </td>
                        <td>
                            <a href="javascript:void 0;" @click="delGoods(item)">删除</a>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="m-shopcart-balance" style="display: flex;">
                <div class="balance-handle" style="flex: 1">
                    <a href="javascript:void 0;" @click="delSelection">删除选中商品</a>
                </div>
                <div class="remark">
                    <el-input type="textarea" :rows="4" placeholder="请输入询价备注" v-model="Remark"> </el-input>
                </div>
                <div class="balance-money">
                    <p>
                        <a href="javascript:void 0;" class="btn-submit" @click="submit">提交</a>
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import { GlobalFun } from '@/common/utils';
import { OrderApi, ShopCartApi, InquiryOrderApi } from '../common/api';
export default {
    name: 'InquiryOrder',
    data() {
        return {
            loading: false,
            selectAll: true,
            inquiryList: [],
            userinfo: null,
            sumPrice: 0,
            CostCenters: [],
            CostCenterValue: '',
            Remark: ''
        };
    },
    methods: {
        selectAllF() {
            if (this.selectAll) {
                $('.select.tb-check').prop('checked', true);
            } else {
                $('.select.tb-check').prop('checked', false);
            }
        },
        submit() {
            this.loading = true;
            let items = $('.tb-check:checkbox');
            let subData = [];
            for (let i = 0; i < items.length; i++) {
                if ($(items[i]).prop('checked')) {
                    let item = this.inquiryList[i];
                    for (let j = 0; j < this.inquiryList.length; j++) {
                        if (this.inquiryList[j].Id == item.Id) {
                            subData.push({
                                SKUID: this.inquiryList[j].Skuid,
                                SKUName: this.inquiryList[j].Skuname,
                                CustSKU: this.inquiryList[j].CustSKU,
                                PicName: this.inquiryList[i].PicName
                            });
                        }
                    }
                }
            }
            if (subData.length == 0) {
                this.$message({
                    message: '请添加商品',
                    type: 'info'
                });
                this.loading = false;
                return;
            }
            let data = {
                Remark: this.Remark,
                Detail: subData
            };
            InquiryOrderApi.SubmitIsmpInquiry(data)
                .then(() => {
                    this.$message({
                        message: '提交成功',
                        type: 'success'
                    });
                    window.location.reload();
                    //this.$router.push('/OrderList');
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        //单个删除
        delGoods(item) {
            this.$confirm('是否删除该询价单?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                center: true
            })
                .then(async () => {
                    InquiryOrderApi.InquirySheetRemove([item.Id]).then(() => {
                        InquiryOrderApi.GetInquirySheetInCart().then(res => {
                            this.inquiryList = [];
                            this.inquiryList = [...res];
                            for (let item of this.inquiryList) {
                                item.CustSKU = '';
                            }
                            this.$message({
                                message: '删除成功',
                                type: 'success'
                            });
                        });
                    });
                })
                .catch(() => {});
        },
        //单个选
        checkedChange(key) {
            let checks = $('.select.tb-check');

            for (let i = 0; i < checks.length; i++) {
                if ($(checks[i]).prop('checked')) {
                    this.selectAll = true;
                } else {
                    this.selectAll = false;
                    break;
                }
            }
        },
        //多选删除
        delSelection() {
            this.$confirm('是否删除选中商品?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                center: true
            }).then(() => {
                let items = $('.tb-check:checkbox');
                let ids = [];
                let tempArr = Object.assign([], this.inquiryList);
                for (let i = 0; i < items.length; i++) {
                    if ($(items[i]).prop('checked')) {
                        ids.push(tempArr[i].Id);
                    }
                }
                //删除
                InquiryOrderApi.InquirySheetRemove(ids).then(() => {
                    InquiryOrderApi.GetInquirySheetInCart().then(res => {
                        this.inquiryList = [];
                        this.inquiryList = [...res];
                        for (let item of this.inquiryList) {
                            item.CustSKU = '';
                        }
                        this.$message({
                            message: '删除成功',
                            type: 'success'
                        });
                        let items = $('.tb-check:checkbox');
                        for (let i = 0; i < items.length; i++) {
                            $(items[i]).prop('checked', true);
                        }
                    });
                });
            });
        }
    },

    async created() {
        this.loading = true;
        GlobalFun.getCookie('UserInfo').then(res => {
            if (!res) {
                this.$router.push('/login');
            } else {
                InquiryOrderApi.GetInquirySheetInCart()
                    .then(res => {
                        this.inquiryList = res;
                        for (let item of this.inquiryList) {
                            this.$set(item, 'CustSKU', '');
                        }
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            }
        });
    }
};
</script>

<style>
.remark {
    margin-right: 10px;
}
@import url('../assets/css/shopcart.css');
</style>
